import script from "./AddBehaviorOccurrence.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBehaviorOccurrence.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__